export default __webpack_public_path__ + "static/img7-a5d304225483c539083e69778520b1b5.png";